import { txns } from './store/txnMiddleware'
import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import segmap from "./modules/segmap/data/reducers"
import ledgermap from "./modules/ledgermap/data/reducers"
import itemmap from "./modules/itemmap/data/reducers"
import txnsync from "./modules/txnsync/data/reducers"
import login from "./modules/login/data/reducers"
import dataDownload from './modules/downloaddata/data/reducers'
import dataUpload from './modules/uploaddata/data/reducers'
import logUpload from './modules/log-upload/data/reducers'
import reportsDownload from './modules/reports/data/reducers'
import vtype from './modules/vtype/data/reducers'
import archive from './modules/archivedata/data/reducers'
import marutiSync from './modules/marutisync/data/reducers'
import vtparammap from './modules/vtparammap/data/reducers'
import vinWiseOpening from './modules/vinWiseOpening/data/reducers'
import uploader from './modules/uploader/data/reducers'
import ledgerSearchReducer from './modules/ledger_search/data/reducers'
import godownSearchReducer from './modules/godown_search/data/reducers'
import itemNameSearchReducer from './modules/itemName_search/data/reducers'

import commonReducers from './modules/common/data/reducers'


const rootReducer = (history) => combineReducers({
    router: connectRouter(history),
    txns,
    segmap,
    ledgermap,
    itemmap,
    txnsync,
    login,
    dataDownload,
    dataUpload,
    logUpload,
    reportsDownload,
    vtype,
    archive,
    marutiSync,
    vtparammap,
    vinWiseOpening,
    uploader,
    commonReducers,
    ledgerSearchReducer,
    godownSearchReducer,
    itemNameSearchReducer,
})

export default rootReducer